import logo from '../../assets/static/comunidad_blanco.webp';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import authService from '../../services/api/auth';
import { clickableStyles } from '../helpers';
import { StyledHeader } from 'src/assets/styles/components/Header';

const Header = () => (
  <StyledHeader id="nav">
    <Link to={'/'}>
      <img className="header__img" src={logo} alt="Logo Comunidad" />
    </Link>
    {!window.location.pathname.includes('dashboard') && (
      <p
        style={{ ...clickableStyles, margin: '0 0 0 auto' }}
        onClick={() => authService.logout()}
        className="logout"
      >
        {localStorage.getItem('userToken') ? (
          <span>Cerrar sesión</span>
        ) : (
          <span>Entra como staff</span>
        )}
      </p>
    )}
  </StyledHeader>
);

export default Header;
